// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PayorAccountPharmacyCoverageModel } from './payorAccountPharmacyCoverageModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PayorAccountPharmacyCoverageModels {
    'success': boolean;
    'notSuccessful'?: boolean;
    'messages': Array<string> | null;
    'data': Array<PayorAccountPharmacyCoverageModel> | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PayorAccountPharmacyCoverageModels>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "notSuccessful",
            "baseName": "notSuccessful",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "Array<PayorAccountPharmacyCoverageModel>"
        },
    ];

    static getAttributeTypeMap() {
        return PayorAccountPharmacyCoverageModels.attributeTypeMap;
    }
}
